import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[liebherrDropFile]',
})
export class DropFileDirective {
    @HostBinding('class.fileover') fileOver = false;

    @Output() filesChanged = new EventEmitter<FileList>();

    @HostListener('dragover', ['$event'])
    onDragOver(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = true;
    }
    @HostListener('dragleave', ['$event'])
    onDragLeave(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = false;
    }
    @HostListener('drop', ['$event'])
    onDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = false;
        // emit fileList
        this.filesChanged.emit(event.dataTransfer.files);
    }
}
